import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";

import {
  IGroup,
} from "./../../../models/Authentication/MenuAccess.models";

import {
  getMenus,
  getPagesAccess,
  getSpecialAccessUsernames,
} from "src/store/Authentication/authSelectors";
import { MenuType } from "src/models/General/ConfigurationMenu.model";
import { getIsMenuCollapsed, setIsMenuCollapsed } from "src/services/Stores/FilteredStoreService";
import { canShowPagePath } from "src/services/Authentication/AccessService";
import { RootState } from "src/store/reducers";
import bank_blue from "../../../assets/icons/bank_blue.png";
import bank_white from "../../../assets/icons/bank_white.png";
import dashboard_blue from "../../../assets/icons/dashboard_blue.png";
import dashboard_white from "../../../assets/icons/dashboard_white.png";

interface IGroupProps {
  group: IGroup;
  pagesAccessURLS: string[];
  username?: string;
  allowedUsernames: string[];
  isCollapsed: boolean;
  props?: any;
}

const SideBarItem = ({ group, pagesAccessURLS, username, allowedUsernames, isCollapsed, ...props }: IGroupProps) => {
  let location = useLocation();
  let match = group.items.filter(item => item.pathURL === location.pathname).length > 0;
  let matchDash = "/dashboard" === location.pathname;
  let icon = group.name == 'Bancos' ? 
    <div className="menu-icon">
      <img src={match ? bank_blue : bank_white } alt={group.name} />
    </div>
    : group.name == 'Dashboard' ? 
      <div className="menu-icon">
        <img src={matchDash ? dashboard_blue : dashboard_white } alt={group.name} />
      </div>
    : group.groupIcon && (
      <div className="menu-icon">
        <i className={group.groupIcon}></i>
      </div>
    );

  let caret = group.items && group.name != "Dashboard" && <div className="menu-caret"></div>;
  let title = group.name && <div className="menu-text">{group.name}</div>;

  return (
    <div
      className={
        "menu-item" + (match ? " active" : "") + (group.items && group.name != "Dashboard" ? " has-sub" : "")
      }
      style={{cursor:"pointer", marginBottom: isCollapsed ? '14px' : ""}}
      onClick={() => {
        if(isCollapsed)
          setIsMenuCollapsed(false);
      }}
    >
      {
        group.name != "Dashboard" ? 
        <NavLink className="menu-link" to={"#"} id={"noootcolla"} {...props} >
          {
            isCollapsed ? <>
              {icon}
            </>
            : <>
              {icon} {title}
              {caret}
            </>
          }
        </NavLink>
        :
        <NavLink className="menu-link" to={`/#`} {...props}>
          {
            isCollapsed ? <>
              {icon}
            </>
            : <>
              {icon} {title}
              {caret}
            </>
          }
        </NavLink>
      }

      {group.items && group.name != "Dashboard" && !isCollapsed && (
        // <div key={generateRandomValue()} className={'menu-submenu'}>
        <div key={group.groupId} className={"menu-submenu"}>
          {group.items
            .filter(item => canShowPagePath(item.pathURL, pagesAccessURLS, username, allowedUsernames))
            .sort((a, b) => a.order - b.order)
            .map((item, i) => {
              let match = item.pathURL === location.pathname;
              return (
                <div key={i} className={"menu-item" + (match ? " active" : "")}>
                  <NavLink className="menu-link" to={item.pathURL} {...props}>
                    {item.name}
                  </NavLink>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

const IconSideBarItem = ({ group, pagesAccessURLS, ...props }: IGroupProps) => {
  let location = useLocation();
  let match = group.items.filter(item => item.pathURL === location.pathname).length > 0;
  let matchDash = "/dashboard" === location.pathname;

  let icon = group.name == 'Bancos' ? 
  <div className="menu-icon">
    <img src={match ? bank_blue : bank_white } alt={group.name} />
  </div>
  : group.name == 'Dashboard' ? 
  <div className="menu-icon">
    <img src={matchDash ? dashboard_blue : dashboard_white } alt={group.name} />
  </div>
  : group.groupIcon && (
    <div className="menu-icon">
      <i className={group.groupIcon}></i>
    </div>
  );

  return (
    <div
      className={
        "menu-item" + (match ? " active" : "") + (group.items && group.name != "Dashboard" ? " has-sub" : "")
      }
      style={{cursor:"pointer" ,marginBottom: '14px'}}
      onClick={() => {
        setIsMenuCollapsed(false);
      }}
    >
      <NavLink id={"ïmcollapsed"} to={`${group.name != "Dashboard" ? "#" : "/#"}`} className="menu-link" {...props}>
        {icon}
      </NavLink>
    </div>
  );
};

const SidebarNav = () => {
  const menus = useSelector(getMenus());
  const pagesAccess = useSelector(getPagesAccess());
  const username = useSelector((state: RootState) => state.auth.user?.username);
  const allowedUsernames = useSelector(getSpecialAccessUsernames);
  const pagesAccessURLS: string[] =
    pagesAccess?.map((page: any) => page.pageURL) || [];

  let canSeeDashboard = pagesAccessURLS.includes("/dashboard")
  // Si canSeeDashboard, agregar a group.items el dashboard, con menuId 99999 itemIcon = iconDashboard, name=  = Dashboard e order -1 para que vaya primero que todo
  if (canSeeDashboard && menus && !menus.filter(menu => menu.menuType === MenuType.SIDEBAR)[0].groups.some(group => group.items.find((item) => item.pathURL === "/dashboard"))) 
    menus.filter(menu => menu.menuType === MenuType.SIDEBAR)[0].groups.unshift({
      groupId: 99999,
      groupIcon: '',
      name: "Dashboard",
      description: "",
      items: [
        {
          menuId: 99999,
          itemIcon: '',
          name: "Dashboard",
          pathURL: "/dashboard",
          order: -1
        }
      ],
      order: -1
    });

    const [isMenuCollapsed, setIsMenuCollapsed] = useState(getIsMenuCollapsed());

    useEffect(() => {
      const handleMenuCollapseChange = () => {
        setIsMenuCollapsed(getIsMenuCollapsed());
      };
  
      // Evento que se dispara cuando el menú se colapsa/expande
      window.addEventListener('menuCollapseChange', handleMenuCollapseChange);
  
      return () => {
        window.removeEventListener('menuCollapseChange', handleMenuCollapseChange);
      };
    }, []);

    
  return (
    <div
      id="mainsidebar"
      className="menu data-disable-slide-animation"
      data-disable-slide-animation="data-disable-slide-animation"
    >
      {menus
        ?.filter(menu => menu.menuType === MenuType.SIDEBAR)
        .map((menu, i) => {
          return (
            <React.Fragment key={i}>
                <div className="menu-header" style={{fontWeight: 'bold'}}>{
                  !isMenuCollapsed ? menu.name : '\u00A0'} </div>
              {menu.groups
                .filter(
                  group =>
                    group.items.filter(item =>
                      canShowPagePath(item.pathURL, pagesAccessURLS, username, allowedUsernames)
                    ).length > 0
                  )
                .sort((a, b) => a.order - b.order)
                .map((group: IGroup, i: number) => (
                  <SideBarItem
                    key={i}
                    group={group}
                    pagesAccessURLS={pagesAccessURLS}
                    username={username}
                    allowedUsernames={allowedUsernames}
                    isCollapsed={isMenuCollapsed}
                  />
                ))}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default SidebarNav;
